import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import { accountReducer } from 'entities/Account/Account.slice';
import { addressReducer } from 'entities/Address/Address.slice';
import { authReducer } from 'entities/Auth/Auth.slice';
import { basketReducer } from 'entities/Basket/Basket.slice';
import { brandReducer } from 'entities/Brand/Brand.slice';
import { buyerReducer } from 'entities/Buyer/Buyer.slice';
import { catalogReducer } from 'entities/Catalog/Catalog.slice';
import { categoryReducer } from 'entities/Category/Category.slice';
import { cityReducer } from 'entities/City/City.slice';
import { contractReducer } from 'entities/Contract/Contract.slice';
import { deliveryReducer } from 'entities/Delivery/Delivery.slice';
import { discountReducer } from 'entities/Discount/Discount.slice';
import { fileReducer } from 'entities/File/File.slice';
import { goodReducer } from 'entities/Goods/Good.slice';
import { inventoryReducer } from 'entities/Inventory/Inventory.slice';
import { inventoryActionReducer } from 'entities/InventoryAction/InventoryAction.slice';
import { invitationReducer } from 'entities/Invitation/Invitation.slice';
import { legalReducer } from 'entities/LegalEntity/Legal.slice';
import { propertyReducer } from 'entities/Property/Property.slice';
import { requestReducer } from 'entities/Request/Request.slice';
import { requestHistoryReducer } from 'entities/RequestHistory/RequestHistory.slice';
import { rfpReducer } from 'entities/Rfp/Rfp.slice';
import { searchReducer } from 'entities/Search/Search.slice';
import { selfRegistrationReducer } from 'entities/SelfRegistration/SelfRegistration.slice';
import { sellerReducer } from 'entities/Seller/Seller.slice';
import { stockReducer } from 'entities/Stock/Stock.slice';
import { subdivisionReducer } from 'entities/Subdivision/Subdivision.slice';
import { supplyReducer } from 'entities/Supply/Supply.slice';
import { uiReducer } from 'entities/UI/UI.slice';
import { userReducer } from 'entities/User/User.slice';
import { workspaceReducer } from 'entities/Workspace/Workspace.slice';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const rootReducer = combineReducers({
  router: routerReducer,
  account: accountReducer,
  address: addressReducer,
  auth: authReducer,
  basket: basketReducer,
  brand: brandReducer,
  buyer: buyerReducer,
  catalog: catalogReducer,
  category: categoryReducer,
  city: cityReducer,
  contract: contractReducer,
  delivery: deliveryReducer,
  discount: discountReducer,
  file: fileReducer,
  good: goodReducer,
  inventory: inventoryReducer,
  inventoryAction: inventoryActionReducer,
  invitation: invitationReducer,
  legal: legalReducer,
  property: propertyReducer,
  request: requestReducer,
  requestHistory: requestHistoryReducer,
  rfp: rfpReducer,
  search: searchReducer,
  selfRegistration: selfRegistrationReducer,
  seller: sellerReducer,
  stock: stockReducer,
  subdivision: subdivisionReducer,
  supply: supplyReducer,
  ui: uiReducer,
  user: userReducer,
  workspace: workspaceReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(routerMiddleware),
});

export const history = createReduxHistory(store);
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
